import { useCallback } from "react";
import { CryptoPro } from "./CryptoPro";
import { UseFileSigningResult } from "./types";

export const useFileSigning = (): UseFileSigningResult => {
  const signFile = useCallback(async (file: File) => {
    const signResult = await CryptoPro.signFile(file);

    return signResult;
  }, []);

  return { signFile };
};
